import React from "react";
import {
  Box,
  Heading,
  useTheme,
  Text,
  Button,
  Flex,
  Alert,
  AlertIcon,
  Switch,
} from "@chakra-ui/react";
import { Theme } from "../../theme";
import { FaArrowRight } from "react-icons/fa";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "../../components/Dropdown";
import Input from "../../components/CustomInput";
import ImagePicker from "../../components/ImagePicker";

const ModifyAd = () => {
  const theme = useTheme<Theme>();
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");
  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");

  const [title, setTitle] = React.useState("");
  const [image, setImage] = React.useState("");
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [place, setPlace] = React.useState("");
  const [url, setURL] = React.useState("");
  const [adStatus, setAdStatus] = React.useState<boolean>(false);
  const [createStatus, setCreateStatus] = React.useState("");

  const toDatetimeLocal = (isoString: string) => {
    const formatted = new Date(isoString).toISOString().split("T")[0]; // "YYYY-MM-DD"
    return formatted;
  };

  const getAdvertisement = async () => {
    try {
      const res = await axios.get(`/advertisements/${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("x-admin-auth")}`,
        },
      });
      setTitle(res.data.title);
      setImage(res.data.img);
      setStartDate(toDatetimeLocal(res.data.start_at));
      setEndDate(toDatetimeLocal(res.data.end_at));
      setPlace(res.data.place);
      setURL(res.data?.url);
      setAdStatus(res.data.status === "running" ? true : false);
    } catch (error) {
      console.log("error", error);
    }
  };

  React.useEffect(() => {
    getAdvertisement();
  }, []);

  const modifyAdvertise = async (e: React.BaseSyntheticEvent) => {
    e.preventDefault();
    const data = {
      title: title,
      img: image,
      start_at: new Date(startDate).toISOString(),
      end_at: new Date(endDate).toISOString(),
      place: place,
      status: adStatus ? "running" : "pending",
    };
    try {
      const res = await axios.put(`/advertisements/${id}`, data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setCreateStatus("updated");
      console.log("submit", res);
      setTimeout(() => {
        navigate("/advertisement");
      }, 2000);
    } catch (error) {
      console.log(error);
      setCreateStatus("error");
    }
  };

  function deleteImage() {}

  function onImageUploadSuccess(val: any) {
    setImage(val);
  }

  const [validationError, setValidationError] = React.useState(false);

  return (
    <Box style={{ padding: "2rem" }}>
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading2,
          marginBottom: theme.space["3xl"],
        }}
      >
        Update Advertisement
      </Text>
      <Box
        style={{
          width: "50%",
          backgroundColor: "#FFFFFF",
          padding: "2rem",
          borderRadius: "8px",
        }}
      >
        <Box style={{ marginBottom: theme.space["xl"] }}>
          <label>Advertisement Banner:</label>

          <Text
            sx={{
              fontSize: theme.fontSizes.caption,
              marginTop: theme.space.xs,
              marginBottom: theme.space.xs,
            }}
            color={theme.colors.secondary.light}
          >
            Use images under 100KB with a 1:1 to 16:9 aspect ratio to ensure
            optimal performance in the Zippy app, where images render in real
            time.
          </Text>

          <ImagePicker
            url={image}
            handleDeleteButton={deleteImage}
            width={"200px"}
            height={"150px"}
            setUrl={onImageUploadSuccess}
            validationRequired={true}
            lowerRange={1}
            upperRange={3}
            requiredSize={102400}
            setValidationError={(val) => {
              setValidationError(val);
            }}
          />
        </Box>

        {validationError && (
          <Alert status="error" borderRadius={"4px"} marginBottom={"1rem"}>
            <AlertIcon />
            Image size should be under 100KB with an aspect ratio ranging from
            1:1 to 16:9.
          </Alert>
        )}

        <form onSubmit={modifyAdvertise}>
          <Flex flexDirection={"column"}>
            <label>Advertisement Name:</label>
            <Input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              name="title"
              placeholder="Ad Title"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Redirect URL
            </label>
            <Input
              type="text"
              value={url}
              onChange={(e) => setURL(e.target.value)}
              name="image"
              placeholder="https://example.com"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Advertisement Start date:
            </label>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              name="startDate"
              placeholder="Ad startDate"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Advertisement End date:
            </label>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              name="endDate"
              placeholder="Ad endDate"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Advertisement Screen:
            </label>
            <Dropdown
              name="place"
              id="currencySearchInput"
              variant="secondaryOutline"
              value={place}
              selectOptions={[
                { title: "Home Page", value: "home" },
                { title: "Search Page", value: "search" },
                { title: "Ride Ongoing", value: "onprogress" },
                { title: "Ride Complete", value: "complete" },
              ]}
              placeholder="Select a place"
              onChange={(e) => setPlace(e.value)}
            />

            <Flex
              sx={{
                gap: "1rem",
                alignItems: "center",
                marginTop: theme.space.xl,
              }}
            >
              <Text
                sx={{
                  fontSize: theme.fontSizes.caption,
                  marginTop: theme.space.sm,
                }}
                color={theme.colors.secondary.light}
              >
                Publish this advertisement to your app now?
              </Text>
              <Switch
                isChecked={adStatus}
                colorScheme="red"
                size="sm"
                style={{ marginTop: "0.5rem" }}
                onChange={() => {
                  setAdStatus(!adStatus);
                }}
              />
            </Flex>

            <Box sx={{ marginTop: theme.space.xxl }}>
              <Button
                type="submit"
                width="100%"
                height="3rem"
                rightIcon={<FaArrowRight />}
                // isLoading={isLoginLoading ? true : false}
                style={{
                  background: theme.colors.primary.main,
                  color: theme.colors.bg.main,
                }}
              >
                <Text sx={{ fontSize: theme.fontSizes.body }}>Update</Text>
              </Button>
            </Box>

            <Box sx={{ minHeight: "3.25rem" }}>
              {createStatus === "updated" && (
                <Alert status="success">
                  <AlertIcon />
                  Ad. updated successfully.
                </Alert>
              )}
              {createStatus === "error" && (
                <Alert status="error" borderRadius={"4px"}>
                  <AlertIcon />
                  Opps! Something went wrong.
                </Alert>
              )}
            </Box>
          </Flex>
        </form>
      </Box>
    </Box>
  );
};

export default ModifyAd;
